/* eslint-disable wc/no-self-class */
import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { BaseElement, customElement } from '../base-element';
import styles from './carousel-item.scss?inline';

export const tagname = 'ps-carousel-item';
@customElement(tagname)
export class CarouselItemWC extends BaseElement {
  static styles = unsafeCSS(styles);

  connectedCallback() {
    super.connectedCallback();
    this.classList.add('swiper-slide');
    this.classList.add('c-carousel__item');
  }

  render() {
    return html` <div class="c-carousel-item">
      <slot></slot>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-carousel-item': CarouselItemWC;
  }
  enum PSElementTagNameMap {
    'ps-carousel-item' = 'ps-carousel-item',
  }
}
